import { render, staticRenderFns } from "./salmonthcount.vue?vue&type=template&id=4aa532f9&scoped=true&"
import script from "./salmonthcount.vue?vue&type=script&lang=js&"
export * from "./salmonthcount.vue?vue&type=script&lang=js&"
import style0 from "./salmonthcount.vue?vue&type=style&index=0&id=4aa532f9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa532f9",
  null
  
)

export default component.exports